<template>
  <button class="c-ring-width l-flex l-flex--column">
    <div :class="imageClass" />
    <p class="t-paragraph">
      {{ width }}
    </p>
  </button>
</template>

<script>
/**
 * @param {string} width - one of 'Wide', 'Standard', 'Thin', 'Halo', 'Stackable'
 * @param {string} active - one of 'Wide', 'Standard', 'Thin', 'Halo', 'Stackable'
 */
export default {
  name: 'RingWidth',
  props: {
    width: {
      type: String,
      default: 'Standard'
    },
    active: {
      type: String,
      default: ''
    }
  },
  computed: {
    imageClass() {
      const active = this.active
      const width = this.width
      let result = ['c-ring-width__image']
      if (active == width) {
        result.push('c-ring-width__image--active')
      }
      result.push(`c-ring-width__image--${width.toLowerCase()}`)
      return result
    }
  }
};
</script>

<style lang="scss" scoped>
.c-ring-width {
  background-color: transparent;
  border: 0px solid;
  &__image {
    position: relative;
    width: 34px;
    @include themify($themes) {
      background-color: themed('foreground', 'select');
    }
    border-radius: 2px;
    margin-bottom: 5px;
    transition: all .3s ease;

    &--accent {
      margin-top: 20px;
      height: 10px;
      background: url('https://enso-public.s3.us-west-2.amazonaws.com/web-assets/accent_width_icon.svg') no-repeat;
      @include themify($themes) {
        background-color: transparent;
      }
    }
    &--wide {
      margin-top: 10px;
      height: 16px;
    }
    &--standard {
      margin-top: 20px;
      height: 8px;
    }
    &--thin {
      margin-top: 20px;
      height: 6px;
    }
    &--halo {
      margin-top: 20px;
      height: 3.5px;
    }
    &--stackable {
      &,
      &::before,
      &::after {
        margin-top: 20px;
        width: 30px;
        height: 4px;
        @include themify($themes) {
          background-color: themed('foreground', 'select');
        }
        display: inline-block;
        border-radius: 2px;
      }
      &::before,
      &::after {
        left: 50%;
        transform: translateX(-50%);
        content: "";
        position: absolute;
        transition: all .2s;
      }
      &::before {
        top: -28px;
      }

      &::after {
        top: -36px;
      }
    }
    &--active {
      @include themify($themes) {
        background-color: themed('foreground', 'selected');
      }
      &,
      &::before,
      &::after {
        @include themify($themes) {
          background-color: themed('foreground', 'selected');
        }
      }
    }
    &--active.c-ring-width__image--accent {
      @include themify($themes) {
        background-color: transparent;
        background: url('https://enso-public.s3.us-west-2.amazonaws.com/web-assets/accent_width_icon_selected.svg') no-repeat;
      }
      &,
      &::before,
      &::after {
        @include themify($themes) {
          background-color: transparent;
          background: url('https://enso-public.s3.us-west-2.amazonaws.com/web-assets/accent_width_icon_selected.svg') no-repeat;
        }
      }
    }
  }

  &:hover {
    .c-ring-width__image--wide,
    .c-ring-width__image--standard,
    .c-ring-width__image--halo,
    .c-ring-width__image--thin {
      transform: translateY(-5px);
    }

    .c-ring-width__image--accent {
      transform: translateY(-5px);
    }

    .c-ring-width__image--stackable {
      &::before {
        top: -3rem;
      }
      &::after {
        top: -4rem;
      }
    }
  }


}
</style>
